import React from "react";
import { Link } from "react-router-dom";

//importing styles
import styles from "./Navbar.module.scss";

const Navbar = () => {
  // const [toggle, setToggle] = useState(false);

  // const handleToggle = () => {
  //   setToggle(!toggle);
  // };

  return (
    <div className={styles.navbarContainer}>
      <div className={styles.navbarWrapper}>
        <Link to="/" className={styles.logo}>
          PTM
        </Link>
        {/* <div className={styles.navItems}>
          <div className={styles.navItemList}>
            <Link className={styles.navItem} onClick={handleToggle}>
              Categories<span className={styles.chevronDown}> &#9660;</span>
            </Link>
            <div
              className={styles.list}
              style={{ display: toggle ? "flex" : "none" }}
            >
              {categories &&
                categories.map((category, index) => (
                  <Link
                    to={`/category/${category.data.name}`}
                    className={styles.listItem}
                    key={index}
                    onClick={handleToggle}
                  >
                    {category.data.name}
                  </Link>
                ))}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Navbar;
